import { render, staticRenderFns } from "./FilterBaseInfoEdit.vue?vue&type=template&id=b6ccc806&"
import script from "./FilterBaseInfoEdit.vue?vue&type=script&lang=js&"
export * from "./FilterBaseInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports